import { useCallback, useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { celebrate } from "@/lib/celebrate";

export const MILESTONE_LABEL = { 7: "Side by Side · 7 days", 30: "Kindred Streak · 30 days" };

export function useBuddies(refreshKey) {
  const [buddies, setBuddies] = useState([]);
  const [matches, setMatches] = useState({ eligible: false, matches: [] });

  const load = useCallback(async () => {
    const [b, m] = await Promise.all([api.get("/buddies"), api.get("/buddies/matches")]);
    setBuddies(b.data);
    setMatches(m.data);
    const fresh = b.data.find((x) => x.new_milestone);
    if (fresh) {
      celebrate(true);
      toast.success(`${MILESTONE_LABEL[fresh.new_milestone]} — you and ${fresh.partner.handle} did it together.`, { duration: 7000 });
    }
  }, []);

  useEffect(() => { load(); }, [load, refreshKey]);

  const act = async (fn, msg) => {
    try {
      await fn();
      if (msg) toast.success(msg);
      load();
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    }
  };

  return {
    matches, act,
    active: buddies.filter((b) => b.status === "active"),
    incoming: buddies.filter((b) => b.status === "pending" && b.incoming),
    outgoing: buddies.filter((b) => b.status === "pending" && !b.incoming),
  };
}
